import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { VersaoProd, VersaoDebug, TipoCompilacao } from '../../../versao';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  sVersao = TipoCompilacao ? VersaoProd : VersaoDebug;

  menu: any[] = [
    // {
    //   displayName: 'Home',
    //   iconName: 'home',
    //   route: '/pages/dashboard',
    // },
    {
      displayName: 'Cadastros',
      iconName: 'add',
      children: [
        {
          displayName: 'Fornecedor',
          iconName: '',
          route: '/pages/novo-fornecedor'
        },
        {
          displayName: 'Grupo',
          iconName: '',
          route: '/pages/novo-grupo'
        },
        {
          displayName: 'Produto',
          iconName: '',
          route: '/pages/novo-produto'
        },
        {
          displayName: 'Unidade de Medida',
          iconName: '',
          route: '/pages/novo-unidade-medida'
        },
        {
          displayName: 'Usuários',
          iconName: '',
          route: '/pages/novo-usuario',
          children: [
            {
              displayName: 'Cliente',
              iconName: '',
              route: '/pages/novo-cliente'
            },
            {
              displayName: 'Funcionário',
              iconName: '',
              route: '/pages/novo-funcionario'
            },
          ]
        },
      ]
    },
    {
      displayName: 'Consultas',
      iconName: 'search',
      children: [
        {
          displayName: 'Fornecedor',
          iconName: '',
          route: '/pages/consultar-fornecedor'
        },
        {
          displayName: 'Grupos',
          iconName: '',
          route: '/pages/consultar-grupo'
        },
        {
          displayName: 'Produto',
          iconName: '',
          route: '/pages/consultar-produto'
        },
        {
          displayName: 'Unidade de Medida',
          iconName: '',
          route: '/pages/consultar-unidade-medida'
        },
        {
          displayName: 'Usuários',
          iconName: '',
          route: '/pages/consultar-usuário',
          children: [
            {
              displayName: 'Cliente',
              iconName: '',
              route: '/pages/consultar-cliente'
            },
            {
              displayName: 'Funcionário',
              iconName: '',
              route: '/pages/consultar-funcionario'
            },
          ]
        },
      ]
    }
  ];

  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  navegar(e) {
    console.log(e)
    e ? this.router.navigate([e]) : null;
  }

}
